/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { useState } from 'react';

import { Popover } from '@coursera/cds-core';

import { shouldEnableAutoPublishedProjects } from 'bundles/employability-common/feature-flags/learnerProfileEpicFeatureFlags';
import NotificationIcon from 'bundles/notification-center/components/NotificationIcon';
import NotificationListView from 'bundles/notification-center/components/NotificationListView';
import NotificationCenterDataProvider from 'bundles/notification-center/components/data/NotificationCenterDataProvider';

const styles = {
  popoverBody: css`
    max-width: 400px;
  `,
};

const NotificationCenter = () => {
  const [popoverAnchor, setPopoverAnchor] = useState<null | HTMLButtonElement>(null);
  const isOpen = Boolean(popoverAnchor);
  const toggleActive = (e: React.MouseEvent<HTMLButtonElement>) => {
    setPopoverAnchor(e.currentTarget);
  };

  return (
    <NotificationCenterDataProvider>
      {({ loading, error, refetch, notifications, markNotificationAsRead, markAllNotificationsAsRead }) => {
        const filteredNotifications =
          notifications?.filter((notification) => {
            if (notification.messageType === 'CapstoneCompletionNotificationMessage') {
              if (!shouldEnableAutoPublishedProjects()) {
                return false;
              }
            }
            return true;
          }) ?? [];

        if (loading || error || !notifications) {
          return (
            <div>
              <NotificationIcon unreadCount={0} onClick={(e) => toggleActive(e)} />
            </div>
          );
        }

        const unreadCount = filteredNotifications?.filter((notification) => {
          if (notification.messageType === 'PartnerIncentiveMessage') {
            return false;
          }
          return !notification.isRead;
        }).length;

        return (
          <div>
            <NotificationIcon unreadCount={unreadCount} onClick={toggleActive} isOpen={isOpen} />
            <Popover
              open={isOpen}
              anchorElement={popoverAnchor}
              onClose={() => setPopoverAnchor(null)}
              drawerProps={{ autoFocus: false }}
            >
              <Popover.Body tabIndex={0} css={styles.popoverBody}>
                <NotificationListView
                  unreadCount={unreadCount}
                  notifications={filteredNotifications}
                  refetchNotifications={refetch}
                  markNotificationAsRead={markNotificationAsRead}
                  markAllNotificationsAsRead={markAllNotificationsAsRead}
                />
              </Popover.Body>
            </Popover>
          </div>
        );
      }}
    </NotificationCenterDataProvider>
  );
};

export default NotificationCenter;
